/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import 'jrs-ui/src/util/webpackPublicPathSetup';
const importStartup = import('jrs-ui/src/util/mainPagesStartup')
const importMain = () => import('./reportViewer.common');
const importCommonModule = () => import('../commons/commons.main')

importStartup.then(({default: startup}) => startup({
    importCommonModule,
    bundles: [
        "jasperserver_config",
        "jasperserver_messages",
        "jsexceptions_messages",
        "jasperreports_messages",
        "adhoc_messages",
        "ScalableInputControlsBundle",
        "CommonBundle",
        "EmbedVizBundle",
        "DashboardBundle",
        "InputControlsValidation",
        "AdHocBundle",
        "RepositoryResourceBundle",
        "all"
    ],
    settings: [
        "globalConfiguration",
        "inputControls",
        "decimalFormatSymbols",
        "inputControls",
        "treeComponent"
    ]
})).then(importMain)